"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Loader = require("./Loader.styled");

var _Spinner = _interopRequireDefault(require("../Icons/obsolete/Spinner"));

var Loader = function Loader(_ref) {
  var content = _ref.content,
      fullPage = _ref.fullPage;
  return /*#__PURE__*/_react.default.createElement(_Loader.LoaderContainer, {
    "aria-hidden": !0
  }, /*#__PURE__*/_react.default.createElement(_Loader.SpinnerImageContainer, null, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    color: "#929ea4"
  })), /*#__PURE__*/_react.default.createElement(_Loader.LoaderMessage, {
    fullPage: fullPage
  }, content, /*#__PURE__*/_react.default.createElement("br", null)));
};

Loader.propTypes = {
  content: _propTypes.default.string,
  fullPage: _propTypes.default.bool
};
Loader.defaultProps = {
  content: "Loading...",
  fullPage: !1
};
var _default = Loader;
exports.default = _default;